// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"67c9f1afc00e16b5cead","453":"b84cdd7144cebfb1c777","522":"730860d26745eb393cd1"}[chunkId] + ".js";
};